import { Component } from '@angular/core';
import { UiTextComponent } from 'components';

@Component({
	standalone: true,
	selector: 'button[navbar-request-price]',
	template: `
		<text class="button-title"><ng-content></ng-content></text>
	`,
	imports: [UiTextComponent],
	styles: [
		`
			:host {
				display: flex;
				padding: 0 0.75rem;
				justify-content: center;
				align-items: center;
				height: 1.75rem;
				border-radius: 0.25rem;
				background: #f3f3f3;
				border: none;
				cursor: pointer;

				transition: background-color 150ms;

				&:hover {
					background: #1964d4;

					.button-title {
						color: #ffffff;
					}
				}

				.button-title {
					color: #3250ec;
					font-size: 0.875rem;
					font-style: normal;
					font-weight: 500;
					line-height: 1.25rem;

					transition: color 150ms;
				}
			}
		`
	]
})
export class RequestPriceButtonComponent {}
